module.exports = "<template> <sio-time-input config.bind=field value.bind=\"field.value | timeInput\"></sio-time-input> </template> ";